import Image from 'react-bootstrap/Image'
import { useSelector } from 'react-redux'
//
import DownArrowIcon from '../../assets/icons/common/down-arrow.svg'
import { USER_ROLES } from '../../utils/userRole'

function UserSection({ setShowMenu = () => {} }) {
  const { userData, user_role } = useSelector(({ auth }) => auth)
  return (
    <div className='d-flex align-items-center justify-content-end'>
      <div
        className='bg-secondary d-flex justify-content-center align-items-center'
        style={{
          height: 30,
          aspectRatio: 1 / 1,
          overflow: 'hidden',
          borderRadius: '100%',
        }}
        onClick={setShowMenu}
      >
        <Image
          style={{ height: 30 }}
          className='bg-secondary'
          src={
            'https://img.freepik.com/premium-vector/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector-illustration_561158-3383.jpg?semt=ais_incoming'
          }
        />
      </div>
      <div className='d-none d-md-flex align-items-center ms-2'>
        {userData?.user_first_name ||
          (user_role === USER_ROLES.ADMIN ? 'Admin' : 'Customer')}
        <Image src={DownArrowIcon} className='ms-2' />
      </div>
    </div>
  )
}

export default UserSection
